import { QueryClient } from "@tanstack/react-query";

/**
 * Server state for the whole app. Khutbah content is immutable once published
 * and is keyed by khutbah, language and version (brief §12), so it can be
 * cached hard; only the Friday navigator and job progress need to be fresh.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});
